module.exports = __webpack_public_path__ + "img/color-picker.3c9afb1f.png";